<template>
  <!--
    Trait de progression en haut de l'écran : discret, il suffit à dire « ça travaille »
    pour la grande majorité des actions.
  -->
  <v-progress-linear
    v-if="visible"
    class="busy-bar"
    color="primary"
    height="3"
    indeterminate
  />

  <!--
    Attente longue : on nomme l'opération et on chronomètre. Le voile empêche aussi de
    relancer l'action une seconde fois, ce qui est le premier réflexe devant un écran figé.
  -->
  <v-overlay
    :model-value="detailed"
    class="busy-overlay align-center justify-center"
    scrim="#05050c"
    opacity="0.72"
    persistent
    no-click-animation
  >
    <v-card class="busy-card pa-6 d-flex flex-column align-center" color="lightSurface" rounded="xl">
      <v-progress-circular color="primary" indeterminate :size="72" :width="6" class="mb-4" />

      <div class="text-h6 text-center">{{ label }}…</div>

      <div class="text-body-2 text-medium-emphasis mt-1" v-if="count > 1">
        {{ count }} opérations en cours
      </div>

      <div class="text-body-2 text-medium-emphasis mt-2">
        {{ seconds }} s écoulées
      </div>

      <!--
        Le message n'apparaît qu'au bout d'un moment : le dire tout de suite inquiéterait
        sans raison, alors qu'après dix secondes c'est exactement ce qu'on veut lire.
      -->
      <div class="text-caption text-center text-medium-emphasis mt-4 busy-note" v-if="seconds >= 10">
        Le traitement se poursuit sur le serveur, même si cet onglet est fermé.
        Inutile de relancer l'opération.
      </div>
    </v-card>
  </v-overlay>
</template>

<script>
import { busy, count, detailed, elapsed, label, visible } from '@/services/requestState'

/**
 * Indicateur global d'attente.
 *
 * Posé une seule fois dans `App.vue`, il couvre toutes les actions de l'application :
 * elles passent toutes par `callFunction`, qui les compte dans `requestState`. Un écran
 * n'a donc rien à faire pour que son action affiche une attente, et une action ajoutée
 * demain en bénéficiera sans qu'on y pense.
 *
 * Les écrans qui affichent déjà une progression détaillée — le calcul d'une période, par
 * exemple — sont exclus côté `requestState` : deux voyants superposés pour la même
 * opération n'apprennent rien de plus à personne.
 */
export default {
  computed: {
    busy() { return busy.value },
    visible() { return visible.value },
    detailed() { return detailed.value },
    label() { return label.value },
    count() { return count.value },
    seconds() { return Math.floor(elapsed.value / 1000) },
  },
}
</script>

<style scoped>
.busy-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
}
.busy-card {
  min-width: 280px;
  max-width: 380px;
}
.busy-note {
  line-height: 1.4;
}
</style>
